export const css = {
	root: '_2-XfgOdv',
	splash: '_6dqk9A5p',
	' _key': 'ascm-theme/ascm/lcc-app/splash'
};

export default css;
